const BASE_URL = "https://libretranslate.com";

export const TRANSLATE_API = {
  TRANSLATE: "https://libretranslate.de/translate",
  GET_LANGUAGES: BASE_URL + "/languages",
};
